import Button from '@/features/shared/Button';
import { MuiCircularProgress } from '@/features/shared/material-ui';
import MessageBar from '@/features/shared/MessageBar';
import clsx from 'clsx';
import React from 'react';
import { ToggleGroup, ToggleOption } from './components';
import { ToggleMenuProps } from './ToggleMenu.interfaces';
import useStyles from './ToggleMenu.styles';
import { useToggleMenu } from './useToggleMenu';

const ToggleMenu = ({ marketoProps, groups, link, confirmationMessage }: ToggleMenuProps) => {
  const classes = useStyles({});
  const marketoFormRef = React.useRef<HTMLFormElement>(null);

  const {
    form: customForm,
    state,
    messageBarProps,
  } = useToggleMenu({
    groups: [],
    marketoProps,
  });

  const preloaderClassName = clsx(classes.preloader);

  return (
    <>
      <form
        className={classes.marketo}
        ref={marketoFormRef}
        aria-hidden="true"
        data-form={marketoProps?.formId}
      />

      {customForm && (
        <form onSubmit={customForm.handleSubmit} className={classes.root}>
          {groups?.map((group) => (
            <ToggleGroup key={group.title} title={group?.title} description={group?.description}>
              {!!group?.options.length && (
                <div className={classes.options}>
                  {group?.options?.map((option) => (
                    <ToggleOption key={option.value} {...option} form={customForm} />
                  ))}
                </div>
              )}
            </ToggleGroup>
          ))}
          {!!link && (
            <Button
              disabled={customForm.submitting || !state.isDirty}
              className={classes.link}
              size="large"
              type="submit"
              // TODO (Luis Sardon): Implement Resource Bundle for "Please wait" label
              link={{
                ...link,
                displayText: customForm.submitting ? 'Please wait' : link.displayText,
              }}
            />
          )}
        </form>
      )}

      {!customForm && (
        <div className={clsx(classes.preloaderContainer)}>
          <div className={preloaderClassName}>
            <MuiCircularProgress size="4rem" color="inherit" />
          </div>
        </div>
      )}

      {confirmationMessage && (
        <MessageBar {...messageBarProps} message={confirmationMessage} severity="success" />
      )}
    </>
  );
};

export default ToggleMenu;
